var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-row',{staticClass:"fantasy__question justify-center align-end ma-0 pa-2 flex-shrink-1 mb-16"},[_c('p',{staticClass:"text-h5 text-sm-h4 text-md-h4 text-lg-h4 text-xl-h4 ma-0 pa-4 unselectable norddruck"},[_vm._v(" "+_vm._s(_vm.question)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }